import { useCallback, useRef } from 'react'
import { useEvent, useIsomorphicLayoutEffect } from 'react-use'
import { Roboto_Condensed } from 'next/font/google'
import localFont from 'next/font/local'

const roboto = Roboto_Condensed({ weight: ['400', '500'], subsets: ['latin'] })

const helvetica = localFont({
  src: [
    {
      path: './fonts/helvetica-neue-light.woff',
      weight: '300',
      style: 'normal'
    },
    {
      path: './fonts/helvetica-neue-regular.woff',
      weight: '400',
      style: 'normal'
    },
    {
      path: './fonts/helvetica-neue-medium.woff',
      weight: '500',
      style: 'normal'
    },
    {
      path: './fonts/helvetica-neue-bold.woff',
      weight: '700',
      style: 'normal'
    }
  ]
})

export type ThemeProps = {
  fluid?: boolean
  maxWidth?: number
}

// eslint-disable-next-line no-unused-vars
const Theme = ({ fluid = true }: ThemeProps) => {
  const lastViewportWidth = useRef(0)

  const resize = useCallback(() => {
    const viewportWidth = window.innerWidth
    const viewportHeight = window.innerHeight

    if (lastViewportWidth.current === viewportWidth) return
    lastViewportWidth.current = viewportWidth

    const vh = viewportHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  }, [])

  useIsomorphicLayoutEffect(() => resize(), [resize])

  useEvent('resize', resize)

  return (
    <style jsx global>{`
      :root {
        --font-family-helvetica: ${helvetica.style.fontFamily};
        --font-family-roboto: ${roboto.style.fontFamily};

        --font-size: ${fluid ? `clamp(10px, ${(10 / 1440) * 100}vw, 11.5px)` : `10px`};
      }
    `}</style>
  )
}

export default Theme
